import { Link } from "react-router-dom";
import { Calendar, CheckCircle2 } from "lucide-react";
import Reveal from "../Reveal";

const FinalCta = ({ marketingText, onBookDemo }) => (
  <section className="bg-[var(--mk-bg-2)] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-testid="final-cta-section">
    <Reveal className="max-w-7xl mx-auto">
      <div className="relative overflow-hidden bg-[#0F172A] rounded-3xl py-16 md:py-20 px-6 sm:px-12 text-center shadow-2xl">
        <div
          className="absolute inset-0 pointer-events-none"
          aria-hidden="true"
          style={{ background: "radial-gradient(ellipse 700px 320px at 50% 0%, rgba(0,70,190,0.35) 0%, transparent 70%)" }}
        />
        <div className="relative z-10 max-w-2xl mx-auto">
          {marketingText && (
            <span className="inline-block px-4 py-1.5 rounded-full text-[12px] font-bold uppercase tracking-[0.1em] bg-amber-400/15 text-amber-300 border border-amber-400/25 mb-6" data-testid="final-cta-offer">
              {marketingText}
            </span>
          )}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.15] mb-5">
            Start running your business from one platform
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed mb-9">
            Set up your account in minutes and see your first job on the calendar today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5 mb-6">
            <Link to="/register" className="mk-btn mk-btn-white mk-btn-lg w-full sm:w-auto" data-testid="final-cta-trial-button">
              Start Your 7-Day Free Trial
            </Link>
            <button
              onClick={onBookDemo}
              className="mk-btn mk-btn-lg w-full sm:w-auto text-white border-white/25 hover:border-white/60"
              style={{ background: "transparent", borderWidth: "1.5px" }}
              data-testid="final-cta-demo-button"
            >
              <Calendar className="w-4 h-4" /> Book a Demo
            </button>
          </div>
          <p className="flex items-center justify-center gap-1.5 text-[13.5px] text-slate-400 font-medium">
            <CheckCircle2 className="w-4 h-4 text-emerald-400" /> No credit card required
          </p>
        </div>
      </div>
    </Reveal>
  </section>
);

export default FinalCta;
